module.exports = __webpack_public_path__ + "img/banner-oyster.06bdd9ae.png";